// extracted by mini-css-extract-plugin
export var editButton = "_ki-0";